export default "__VITE_ASSET__C82A7y0u__"